<template>
    <div class="container-fluid row m-0 p-0" style="background-color: #000000; display: flex; align-items: center;">
        <div v-if="statusBackGround" class="d-flex justify-content-center w-100">
            <div class="col-md-4 col-12">
                <div class="w-100">
                    <img :src="icon.anhPhongNen" alt="" style="display: block; margin: auto;">
                </div>
            </div>
        </div>
        <div v-if="statusHopMungCuoi" class="d-flex flex-column justify-content-center p-0" style="color: black;background-color: pink;">
            <div class="row w-100 p-0 m-0">
                <span style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 36px;color: red;">
                    HỘP MỪNG CƯỚI
                </span>
            </div>
            <div>
                <div class="d-flex flex-column justify-content-center my-5 p-1" style="border-style: ridge;">
                    <span class="my-2" style="font-size: 25px;">ĐẾN CHÚ RỂ</span>
                    <div class="d-flex flex-column justify-content-center align-items-md-center">
                        <img class="col-md-4 col-12"
                            src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1714121652092b2E5F"
                            alt="">
                    </div>
                    <div class="d-flex flex-column justify-content-center my-2" style="font-size: 24px;">
                        <span>Ngân hàng: TECHCOMBANK</span>
                        <span>Số tài khoản: 3319981998</span>
                        <span>Tên tài khoản: BUI DANG DANH</span>
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-center my-5" style="border-style: ridge;">
                    <span class="my-2" style="font-size: 25px;">ĐẾN CÔ DÂU</span>
                    <div class="d-flex flex-column justify-content-center align-items-md-center">
                        <img class="col-md-4 col-12"
                            src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1714121651982Hp6nF"
                            alt="">
                    </div>
                    <div class="d-flex flex-column justify-content-center my-2" style="font-size: 24px;">
                        <span>Ngân hàng: VPBANK</span>
                        <span>Số tài khoản: 155951998</span>
                        <span>Tên tài khoản: NGUYEN THI BAC</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
import { imageUrlsChiTietCuaHang } from "@/views/wedding/urlAnh";

export default {
    data() {
        return {
            icon: imageUrlsChiTietCuaHang,
            statusBackGround: true,
            statusHopMungCuoi: true
        }
    },
    mounted() {
        document.title = "Danh <3 Bắc";  // Sửa thành thực thể HTML
        this.ThayDoiFavicon();
    },
    methods: {
        ThayDoiFavicon() {
            // Xóa tất cả các thẻ link có rel='icon'
            const headElement = document.getElementsByTagName('head')[0];
            const existingIcons = document.querySelectorAll("link[rel~='icon']");
            existingIcons.forEach(icon => headElement.removeChild(icon));

            // Tạo và thêm thẻ link mới
            const newLink = document.createElement('link');
            newLink.rel = 'icon';
            newLink.href = this.icon.favicon;
            headElement.appendChild(newLink);
        }
    }
}
</script>
